"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _Translations = require("../Translations");
var _formik = require("formik");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BaseStepsForm = /*#__PURE__*/function (_Component) {
  _inherits(BaseStepsForm, _Component);
  var _super = _createSuper(BaseStepsForm);
  function BaseStepsForm(props) {
    var _this;
    _classCallCheck(this, BaseStepsForm);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (values) {
      if (_this.state.activeStep !== _this.props.stepperSteps().length - 1 && (values === null || values === void 0 ? void 0 : values.status) !== "draft") {
        var continueToNext = true;
        if (_this.props.checkBeforeNext) {
          continueToNext = _this.props.checkBeforeNext.bind(_assertThisInitialized(_this))(values);
        }
        if (continueToNext) {
          _this.setState({
            activeStep: _this.state.activeStep + 1
          });
          document.getElementById('stepper-component').scrollIntoView({
            behavior: 'smooth'
          });
        }
      } else {
        var _this$props = _this.props,
          customHandleSubmit = _this$props.customHandleSubmit,
          submitAction = _this$props.submitAction,
          history = _this$props.history,
          pagination = _this$props.pagination,
          match = _this$props.match,
          user = _this$props.user;
        var data = _objectSpread(_objectSpread({}, values), {}, {
          user: user.id
        });
        var formData = new FormData();
        var excludedFields = [];
        // This endpoint is used in the action (edit/create)
        var endpoint = _this.props.endpoint || 'products';
        var postUpdateAction = _this.props.postUpdateAction || 'FETCH_PRODUCTS';
        var redirectAfterActionTo = _this.props.redirectAfterActionTo || '/products';

        // Add the excludedFields provided from the props
        // these keys are excluded from the loop that appends to the formData
        // and are handeled in customHandleSubmit
        if (_this.props.excludedFields) {
          _this.props.excludedFields.forEach(function (key) {
            return excludedFields.push(key);
          });
        }
        _lodash.default.forOwn(data, function (value, key) {
          if (excludedFields.indexOf(key) !== -1) {
            return;
          } else if (value !== undefined && value !== null) {
            formData.append(key, value);
          }
        });

        // Check if a customHandleSubmit function is provided and excute it
        // it takes the data to use it to append to our formData
        if (customHandleSubmit) {
          customHandleSubmit.bind(_assertThisInitialized(_this))(data, formData, _this.props);
        }
        if (submitAction) {
          submitAction.bind(_assertThisInitialized(_this))(formData);
        } else {
          var onSuccess = function onSuccess(product) {
            var isSaveAsDraft = data.status === "draft";
            if (isSaveAsDraft) {
              // if we use save as draft we always stay on the same page
              _this.props.dispatch({
                type: 'REDIRECT',
                to: "".concat(_this.props.location.pathname, "/").concat(product.id),
                history: history
              });
            } else {
              _this.props.dispatch({
                type: 'REDIRECT',
                to: redirectAfterActionTo,
                history: history
              });
            }
            _this.props.dispatch({
              type: "HANDLE_SUCCESS_MESSAGE",
              message: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
                id: "Votre produit a bien \xE9t\xE9 sauvegard\xE9 en tant que brouillon",
                defaultMessage: "Votre produit a bien \xE9t\xE9 sauvegard\xE9 en tant que brouillon"
              })
            });
          };
          if (match.params.id) {
            _this.props.dispatch({
              type: 'UPDATE_PRODUCT',
              endpoint: endpoint,
              redirectAfterActionTo: redirectAfterActionTo,
              postUpdateAction: postUpdateAction,
              model: formData,
              id: match.params.id,
              page: pagination.page,
              history: history,
              onSuccess: onSuccess
            });
          } else {
            _this.props.dispatch({
              type: 'ADD_PRODUCT',
              endpoint: endpoint,
              redirectAfterActionTo: redirectAfterActionTo,
              postUpdateAction: postUpdateAction,
              model: formData,
              page: 1,
              history: history,
              onSuccess: onSuccess
            });
          }
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleConfirm", function () {
      _this.submitForm();
    });
    _defineProperty(_assertThisInitialized(_this), "bindSubmitForm", function (submitForm) {
      _this.submitForm = submitForm;
    });
    _defineProperty(_assertThisInitialized(_this), "handleSaveAsDraft", function () {
      var _this$formikRef;
      if ((_this$formikRef = _this.formikRef) !== null && _this$formikRef !== void 0 && _this$formikRef.current) {
        _this.handleSubmit(_objectSpread(_objectSpread({}, _this.formikRef.current.values), {}, {
          status: "draft"
        }));
      }
    });
    _this.state = {
      activeStep: 0
    };
    _this.formikRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  _createClass(BaseStepsForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check if a componentDidMount function is provided and excute it
      // we pass it the props so the function can use them to dispatch the actions
      if (this.props.componentDidMount) {
        this.props.componentDidMount.bind(this)();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.componentWillUnmount) {
        this.props.componentWillUnmount.bind(this)();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        handleSubmit = _this$props2.handleSubmit,
        classes = _this$props2.classes,
        stepperSteps = _this$props2.stepperSteps,
        inProgress = _this$props2.inProgress,
        match = _this$props2.match;
      var activeStep = this.state.activeStep;
      var Form = this.props.form;
      return /*#__PURE__*/_react.default.createElement(_core.Paper, {
        className: classes && classes.paper
      }, /*#__PURE__*/_react.default.createElement(_core.Stepper, {
        className: "sm:p-8 md:p-16 overflow-auto",
        activeStep: activeStep,
        id: "stepper-component"
      }, stepperSteps().map(function (step, index) {
        return /*#__PURE__*/_react.default.createElement(_core.Step, {
          key: index
        }, /*#__PURE__*/_react.default.createElement(_core.StepButton, {
          onClick: function onClick() {
            return _this2.setState({
              activeStep: index
            });
          }
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: step
        })));
      })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        className: classes && classes.formContainer
      }, /*#__PURE__*/_react.default.createElement(Form, _extends({
        innerRef: this.formikRef,
        activeStep: activeStep,
        handleSubmit: handleSubmit ? handleSubmit : this.handleSubmit,
        bindSubmitForm: this.bindSubmitForm,
        isEdit: match.params.id ? true : false
      }, this.props))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        container: true,
        spacing: 0,
        xs: 12,
        justifyContent: "center",
        className: "pb-4 pt-2"
      }, activeStep !== 0 && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        container: true,
        justify: "flex-end",
        xs: 4
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        variant: "contained",
        color: "secondary",
        className: "p-2",
        disabled: inProgress,
        onClick: function onClick() {
          _this2.setState({
            activeStep: activeStep - 1
          });
          document.getElementById('stepper-component').scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Previous"
      }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        container: true,
        justify: "center",
        xs: 4
      }, activeStep < stepperSteps().length - 1 ? /*#__PURE__*/_react.default.createElement(_core.Button, {
        variant: "contained",
        color: "secondary",
        className: "p-2",
        onClick: this.handleConfirm
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Next"
      })) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        disabled: inProgress,
        variant: "contained",
        color: "primary",
        className: "p-2",
        onClick: this.handleConfirm
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Submit"
      }), inProgress && /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
        size: 24,
        style: {
          position: 'absolute'
        }
      })))), this.props.saveAsDraft && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 4,
        justify: "center"
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        variant: "contained",
        color: "primary",
        className: "p-2",
        disabled: inProgress,
        onClick: this.handleSaveAsDraft
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Save as draft"
      })))));
    }
  }]);
  return BaseStepsForm;
}(_react.Component);
var _default = BaseStepsForm;
exports.default = _default;